import { Location } from "@angular/common";
import { Component, ElementRef, OnInit } from "@angular/core";
import { Router, RouterModule } from "@angular/router";
import Swal from "sweetalert2";
import { AuthService } from "../../services/auth.service";
import { ROUTES } from "../sidebar/sidebar.component";
import { NgbDropdownModule } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"],
  imports: [RouterModule, NgbDropdownModule],
})
export class NavbarComponent implements OnInit {
  public focus: boolean = false;
  public listTitles: any[] = [];
  public location: Location;
  public company: any = {};
  constructor(
    location: Location,
    private element: ElementRef,
    private router: Router,
    private authService: AuthService
  ) {
    this.location = location;
  }

  ngOnInit() {
    this.listTitles = ROUTES.filter((listTitle) => listTitle);
  }

  getTitle() {
    var titlee = this.location.prepareExternalUrl(this.location.path());
    if (titlee.charAt(0) === "#") {
      titlee = titlee.slice(1);
    }

    for (var item = 0; item < this.listTitles.length; item++) {
      if (this.listTitles[item].path === titlee) {
        return this.listTitles[item].title;
      }
    }
    return "Dashboard";
  }

  logout() {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: "Deseja sair?",
        text: "Você vai fazer logout!!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, sair!",
        cancelButtonText: "Não, cancelar!",
        reverseButtons: true,
      })
      .then((result) => {
        if (result.value) {
          try {
            this.authService.logout();
          } catch (error) {
            Swal.fire(
              "Erro!",
              "Não foi possível sair. Tente novamente mais tarde.",
              "error"
            );
          }
        }
      });
  }
}
